<template>
  <ul class="font-size-control list-group">
    <li class="list-group-item text-left"
      v-for="(phrase, phraseIndex) in content" v-if="phrase.name" :key="phraseIndex">
      <div class="title w-100 pl-3" @click="play(phrase)">
        <i class="fa fa-volume-up"></i> <span v-html="phrase.name"></span>
      </div>
      <div class="w-100 pl-3">
        <p class="pre" v-if="phrase.content" v-html="phrase.content"></p>
        <p v-if="phrase.content_result">
          <span v-for="(part, partIndex) in phrase.content_result" :key="partIndex">
            <span v-if="part.audio"
              style="cursor: pointer"
              @click="play({ name: '', audio: part.audio })">
              <i class="fa fa-volume-up"></i> <span v-html="part.text"></span>
            </span>
            <span class="pre" v-html="part.text" v-else></span>
          </span>
        </p>
        <p v-else class="pre" v-html="phrase.content_i18N[0].value"></p>
        <p v-if="phrase.example" v-html="phrase.example"></p>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {

    name: 'Phrases',

    props: {
      data: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      }
    },

    data () {
      return {
        phraseContent: [],
        content: []
      }
    },

    created () {
      this.content = JSON.parse(JSON.stringify(this.data))

      for (let phraseIndex in this.content) {
        // Add Sound
        let content = this.content[phraseIndex].content_i18N[0]
        for (let exAudioIndex in this.content[phraseIndex].extendAudios) {
          let order = this.content[phraseIndex].extendAudios[exAudioIndex].order
          order = order < 10 ? '0' + order : order
          let replace = '<NO' + order + ',(.*?)\r'
          let re = new RegExp(replace, 'g')
          let text = content.value.match(re) ? content.value.match(re)[0] : ''
          if (text === '') {
            content.value = content.value.replace('<NO' + order + ',', '<EX-AUDIO><EX-AUDIO>')
          } else {
            content.value = content.value.replace(text, '<EX-AUDIO>' + text.replace('<NO' + order + ',', '') + '<EX-AUDIO>')
          }

          this.phraseContent.push({
            'order': order,
            'text': text.replace('<NO' + order + ',', ''),
            'audio': this.content[phraseIndex].extendAudios[exAudioIndex].audio
          })
        }

        // Split Sentence
        if (content) {
          this.content[phraseIndex].content_result = content.value.split('<EX-AUDIO>')
          for (let resultIndex in this.content[phraseIndex].content_result) {
            let audio = this.isAudioExist(this.content[phraseIndex].content_result[resultIndex])
            this.content[phraseIndex].content_result[resultIndex] = {
              text: this.content[phraseIndex].content_result[resultIndex],
              audio: audio
            }
          }
        } else {
          this.content[phraseIndex].content_result = ''
        }
      }
    },

    methods: {
      play (data) {
        this.$emit('audio', {
          name: data.name,
          url: data.audio
        })
      },

      isAudioExist (sent) {
        let found = false
        // eslint-disable-next-line
        this.phraseContent.forEach((e, i) => {
          if (sent === e.text) {
            found = e.audio
          }
        })

        return found
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/style/app.scss";

  .title {
    color: $phrase-color;
    font-size: 1.5em;
    cursor: pointer;

    .fa-volume-up {
      color: black;
      cursor: pointer;
    }
  }

  .list-group {
    text-align: left!important;

    .list-group-item {
      border: 0;
      border-bottom: 2px #ccc solid;

      &:last-child {
        border: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Phrases.vue?61f952c2